// generated by genversion
export const version = '6.6.0';
